var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissionIconLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0157 15C10.2414 15 8.8014 13.5606 8.8014 11.787C8.8014 10.0114 10.2414 8.57143 12.0157 8.57143C13.79 8.57143 15.23 10.0114 15.23 11.787C15.23 13.5606 13.79 15 12.0157 15ZM21.9587 17.61C23.1643 15.7711 23.8014 13.6486 23.8014 11.4702C23.8007 5.14841 18.5145 0.00272727 12.0178 0H12.0171C5.52177 0.00272727 0.23414 5.14841 0.22998 11.4702C0.22998 13.6425 0.867102 15.765 2.10946 17.6605L12.0164 30L21.9587 17.61Z"
  })));
}
export default SvgMissionIconLocation;